export default {
  counter: 0
}
